import React from "react";
import InputForm from "../generales/InputForm";
import { capitalizeFirstLetter } from "../../utils/utils";
import { lang } from "../generales/traduction";
import Action from "../Action";
import { useState ,useEffect,useRef} from 'react';
import Modal from "react-modal";

import "./styles/ModalCreateDocs.css";
import LoadSimple from "../LoadSimple";
import {useFetch }from "../../hooks/useFetch";
import { set } from "date-fns";
const hostListModalSyncStyles = {
  content: {
    top: "50%",
    left: "50%",
    background: "#ffffff !important",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "40%",
    height: "90%",
    padding: "20px",
  },
};
const ModalCreateDocs = ({server,handleShowPopup,cisSelected,dataClasifications,buscar_cis_docss,closHostsModal}) => {
  const [loading, setLoading] = useState(false);
  const [cisData, setCisData] = useState({
      name: "",
description: "",
type: "URL",
location: "",
classification_id: null
  });
  const LinkIcon = () => (
<svg width="18" height="18" viewBox="0 0 24 24" fill="none">
  <path
    d="M10.59 13.41a1.5 1.5 0 0 0 2.12 0l3.88-3.88a3 3 0 0 0-4.24-4.24l-1.41 1.41"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
  <path
    d="M13.41 10.59a1.5 1.5 0 0 0-2.12 0l-3.88 3.88a3 3 0 0 0 4.24 4.24l1.41-1.41"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
</svg>
);

  const PdfIcon = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
      <path
        d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 2v6h6"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
  const uploadFile = () => {
       setLoading(true)
          const formData = new FormData();
          // console.log(file.name)
          formData.append('file', archivo, archivo.name);
          formData.append('name', cisData.name);
          formData.append('description', cisData.description);
           formData.append('classification_id', cisData.classification_id);
          fetch(server.url+'/api/v1/cassia/cis_v2/'+cisSelected.id+'/documents/upload', {
            method: 'POST',
            headers: {
              'Authorization': `Bearer ${localStorage.getItem('access_token')}`, // Reemplaza tu_token con tu token de autorización
            },
            body: formData,
          })
          .then(response => response.json())
          .then(data => {
            // document.getElementById('nombre-archivo').textContent =''

            setLoading(false)
            handleShowPopup('Completado','Archivo agregado correctamente','', true)
            closHostsModal()
            buscar_cis_docss()
          })
          .catch(error => {
            console.error('Error al enviar el archivo:', error);
          });
        }
  const addUrl=()=>{
    setLoading(true)
    uploadUrl();  
}
  const uploadUrl = () => {
      const formData = new FormData();
      formData.append('location', cisData.location);
      formData.append('name', cisData.name);
      formData.append('description', cisData.description);
      formData.append('type', "URL");
      formData.append('type', "classification_id");
     
      // formData.append('files', file, file.name);
      fetch(server.url+'/api/v1/cassia/cis_v2/'+cisSelected.id+'/documents/url', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('access_token')}`, // Reemplaza tu_token con tu token de autorización
        },
        body: JSON.stringify(cisData),
      })
      .then(response => response.json())
      .then(data => {
        // document.getElementById('nombre-archivo').textContent =''
        handleShowPopup('Completado','URL agregado correctamente','', true)

        setLoading(false)
        closHostsModal()
        buscar_cis_docss()
      })
      .catch(error => {
        console.error('Error al enviar el archivo:', error);
      });
    }
  const handleChange=(e)=>{
     const {name,value}=e.target
     
      setCisData((prevState)=>{
              return {
                  ...prevState,
                  [name]:value
              }
              
          })
    }
  const changeOption=(option,index)=>{
 
    setCisData((prevState)=>{
           return {
               ...prevState,
               [option.filter]:option.value
           }
           
       })
       
}
  const changeType=(value)=>{
    setTipo(value)
       setCisData((prevState)=>{
              return {
                  ...prevState,
                  ['type']:value
              }
              
          })
          
  }
  const [tipo, setTipo] = useState("URL");
  const inputRef = useRef(null);
  const [dragActive, setDragActive] = useState(false);
  const [archivo, setArchivo] = useState(null)
  const handleFile = (files) => {
    const file = files[0];
    if (file && file.type === "application/pdf") {
      setArchivo(file);
    } else {
      alert("Solo se permite subir archivos PDF");
    }
  };
  const handleDrop = (e) => {
    e.preventDefault();
    setDragActive(false);
    handleFile(e.dataTransfer.files);
  };
  const [disabledBtn, setDisabledBtn] = useState(true);
  function isValidURL(url) {
    const regex = /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/[^\s]*)?$/;
    return regex.test(url);
  }
  useEffect(() => { 
    if(cisData.name=='' || (tipo==='URL' && (cisData.location=='' || !isValidURL(cisData.location))) || (tipo==='pdf' && !archivo) || cisData.classification_id==null){
        setDisabledBtn(true)
    }else{
      setDisabledBtn(false)
    }
  }, [cisData,archivo]);
  return(
      <>
         <div className="create-docs-container">
              <div className="compact-create-docs">
                  <div className="create-docs-titulo">
                      {'Añadir Documentos'}
                  </div>
                  <div className="create-docs-options">
                     <div className="fileType-tab-container">
    <label className={`fileType-tab ${tipo === "URL" ? "active" : ""}`}>
      <input
        type="radio"
        name="tipo"
        value="URL"
        checked={tipo === "URL"}
        onChange={() => changeType("URL")}
      />
      <span className="FileIcon"><LinkIcon /></span>
      <span>URL</span>
    </label>

    <label className={`fileType-tab ${tipo === "pdf" ? "active" : ""}`}>
      <input
        type="radio"
        name="tipo"
        value="pdf"
        checked={tipo === "pdf"}
        onChange={() => changeType("pdf")}
      />
      <span className="FileIcon"><PdfIcon /></span>
      <span>Archivo PDF</span>
    </label>
  </div>
                  </div>
                  <div className="create-docs-body">
                     {cisData.type==='URL'? <div className={"compact-body-step-modal "}>
                <div className="row-form-modal">
                  <div className="colum-form-modal">
                      <InputForm  error={false} type='input' handleInputChange={handleChange}  attr={'name'} titulo={'Nombre'} text={cisData.name} placeHolder={''} disabled={false} isRequired={true}/>
                  </div>
                  <div className="colum-form-modal">
                      <InputForm  error={isValidURL(cisData.location)?false:true} type='input' handleInputChange={handleChange}  attr={'location'} titulo={'URL'} text={cisData.location} placeHolder={'Agrege una URL'} msgError={'el formato ingresado no es una url valida ejemplo: google.com'}disabled={false} isRequired={true}/>
                  </div>
                
                </div>
                
                <div className="row-form-modal">
                  <div className="colum-form-modal">
                      {(dataClasifications.loading)?<div className='load-data-selector' >Cargando Datos. . .</div>:
                      <InputForm optionDefault={0} type='selector' endpoint='field_option'msgError={''}  error={false} changeOption={changeOption}  attr={'classification_id'} titulo={'Clasificacion'} loading={dataClasifications.loading} data={dataClasifications.data.data} text={''} placeHolder={'Selecciona un usuario'} disabled={false} isRequired={cisData.classification_id==null}/>
                      }
                      </div>
                
                </div>
                 <div className="row-form-modal-dobel">
                      <InputForm type='textArea'  error={false} handleInputChange={handleChange}  attr={'description'} titulo={'Descripción'} text={cisData.description} placeHolder={'Agregar comentarios'} disabled={false} isRequired={false} coment={''}/>

                </div>
               
              </div>:
              //formato para archivos
               <div className={"compact-body-step-modal "}>
                <div className="row-form-modal">
                  <div className="colum-form-modal">
                      <InputForm  error={false} type='input' handleInputChange={handleChange}  attr={'name'} titulo={'Nombre'} text={cisData.name} placeHolder={''} disabled={false} isRequired={true}/>
                  </div>
                  <div className="colum-form-modal">
                      {(dataClasifications.loading)?<div className='load-data-selector' >Cargando Datos. . .</div>:
                      <InputForm optionDefault={0} type='selector' endpoint='field_option'msgError={''}  error={cisData.classification_id==null} changeOption={changeOption}  attr={'classification_id'} titulo={'Clasificacion'} loading={dataClasifications.loading} data={dataClasifications.data.data} text={''} placeHolder={'Selecciona un usuario'} disabled={false} isRequired={cisData.classification_id==null}/>
                      }
                      </div>
                
                </div>
                
               <div className="row-form-modal-dobel">
                      <div className="pdf-upload-container">
    <label className=" labelInputFormV2  " style={{color:'var(--third-color)'}}>Archivo <span className="required">*</span></label>

    <div
      className={`drop-zone ${dragActive ? "active" : ""}`}
      onDragOver={(e) => {
        e.preventDefault();
        setDragActive(true);
      }}
      onDragLeave={() => setDragActive(false)}
      onDrop={handleDrop}
      onClick={() => inputRef.current.click()}
      style={{color:'var(--txt-color)',cursor:'pointer',fontSize:'var(--font-size-medium) '}}
    >
      Arrastra tu archivo aquí o <strong>haz clic para seleccionar</strong>
      {archivo && (
        <p className="file-name">
          {archivo.name}
        </p>
      )}
    </div>

    <input
      type="file"
      accept="application/pdf"
      ref={inputRef}
      style={{ display: "none" }}
      onChange={(e) => handleFile(e.target.files)}
    />
  </div>
                </div>
                 <div className="row-form-modal-dobel">
                      <InputForm type='textArea'  error={false} handleInputChange={handleChange}  attr={'description'} titulo={'Descripción'} text={cisData.description} placeHolder={'Agregar comentarios'} disabled={false} isRequired={false} coment={''}/>

                </div>
               
              </div>

                     }
                  </div>
                   <div className="create-docs-footer">
                      <div className="cont-buttons-panel" style={{width:'60%', display:'flex',right:'unset',top:'unset'} }>
                                       {
                                        
                                        (loading)?<LoadSimple></LoadSimple>:
                                         
                                        <>
                                        <Action
                                        disabled={disabledBtn}
                                        origen="Azul"
                                        titulo={'Guardar'}
                                        action={()=>{(tipo==='URL')?addUrl():uploadFile()}}
                                      />
                                      
                                        </>
                                        
                                       }
                                          
                                        
                                          <Action
                                      disabled={false}
                                      origen="Cancelar"
                                      titulo={"Cancelar"}
                                      action={()=>{ closHostsModal() }}
                                    />
                                      </div>
                  </div>
              </div>
         </div>
      </>
  )
}

export default ModalCreateDocs;
 